import React, { useState, useEffect } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { Container, Card, CardBody, Table, Button, Spinner } from "reactstrap";
import { useDispatch } from "react-redux";
import { loadingTrue, loadingFalse } from "../../Reducer/loaderSlice";
import Handler from "../../Helpers/Handler";
import { toast } from "react-toastify";
import dayjs from "dayjs";

// 🔥 Machan, assets folder la irundhu logo eduthutaen
import logo from "../../Assets/images/logo-1.png";

const PurchaseReceiptView = () => {
    const { id } = useParams();
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const [data, setData] = useState(null);

    useEffect(() => {
        fetchPurchaseDetails();
    }, [id]);

    const fetchPurchaseDetails = async () => {
        dispatch(loadingTrue());
        try {
            const res = await Handler({ method: "GET", url: `/purchase/view.php?id=${id}` });
            if (res?.success) {
                setData(res.data);
            } else {
                toast.error(res?.message || "Purchase record not found");
            }
        } catch (err) {
            toast.error("Server error occurred");
        } finally {
            dispatch(loadingFalse());
        }
    };

    if (!data) return <div className="p-5 text-center"><Spinner color="danger" /></div>;

    const { purchase, farmer, product, sacks, summary } = data;

    return (
        <Container className="py-4 d-flex flex-column align-items-center bg-light min-vh-100">
            {/* Action Buttons */}
            <div className="d-flex justify-content-between w-100 mb-4 no-print" style={{ maxWidth: "400px" }}>
                <Button color="secondary" outline size="sm" onClick={() => navigate(-1)}>
                    <i className="bx bx-left-arrow-alt"></i> Back
                </Button>
                {/* <Button color="danger" size="sm" onClick={() => window.print()}>
                    <i className="bx bx-printer"></i> Print Receipt
                </Button> */}
            </div>

            {/* Thermal Receipt Paper */}
            <Card className="border-0 shadow-sm" style={{ width: "80mm", color: "#000", fontFamily: "'Courier New', Courier, monospace" }}>
                <CardBody className="p-3">

                    {/* Header Block */}
                    <div className="text-center mb-2">
                        <img src={logo} alt="Logo" style={{ width: "50px", marginBottom: "5px" }} />
                        <h6 className="fw-bold m-0" style={{ fontSize: "16px" }}>MUTHIAH COTTON MILL</h6>
                        <p className="m-0 small" style={{ fontSize: "10px" }}>Cotton & Cotton Seeds Merchant</p>
                        <p className="m-0 small" style={{ fontSize: "10px" }}>Mobile: 9659285595</p>
                        <div className="border-top border-bottom my-2 py-1 fw-bold text-uppercase" style={{ fontSize: "12px" }}>
                            Purchase Receipt
                        </div>
                    </div>

                    {/* Farmer Details */}
                    <div className="mb-3" style={{ fontSize: "12px" }}>
                        <div className="fw-bold border-bottom mb-1 small text-uppercase">Farmer Details</div>
                        <div className="d-flex justify-content-between"><span>Name</span><span>: {farmer.name}</span></div>
                        <div className="d-flex justify-content-between"><span>Phone</span><span>: {farmer.phone}</span></div>
                    </div>

                    {/* Purchase Details */}
                    <div className="mb-3" style={{ fontSize: "12px" }}>
                        <div className="fw-bold border-bottom mb-1 small text-uppercase">Purchase Details</div>
                        <div className="d-flex justify-content-between"><span>Bill No</span><span>: {purchase.purchase_no}</span></div>
                        <div className="d-flex justify-content-between"><span>Product</span><span>: {product.name}</span></div>
                        <div className="d-flex justify-content-between"><span>Date</span><span>: {dayjs(purchase.purchase_date).format("DD-MM-YYYY")}</span></div>
                    </div>

                    {/* Sacks Weights Table */}
                    <div className="mb-3">
                        <div className="fw-bold border-bottom mb-1 small text-uppercase text-center" style={{ fontSize: "12px" }}>Sacks Weights</div>
                        <Table size="sm" borderless className="m-0" style={{ fontSize: "11px" }}>
                            <thead className="border-bottom">
                                <tr>
                                    <th className="py-1">#</th>
                                    <th className="py-1 text-end">Weight (Kg)</th>
                                </tr>
                            </thead>
                            <tbody>
                                {sacks.map((sack, idx) => (
                                    <tr key={idx}>
                                        <td className="py-1">{idx + 1}</td>
                                        <td className="py-1 text-end">{parseFloat(sack.weight).toFixed(2)}</td>
                                    </tr>
                                ))}
                            </tbody>
                        </Table>
                    </div>

                    {/* Summary Calculation */}
                    <div className="border-top pt-2" style={{ fontSize: "13px" }}>
                        <div className="fw-bold border-bottom mb-1 small text-uppercase text-center">Summary</div>
                        <div className="d-flex justify-content-between">
                            <span>Total Kg</span>
                            <span className="fw-bold">{parseFloat(summary.total_weight).toFixed(2)}</span>
                        </div>
                        <div className="d-flex justify-content-between">
                            <span>Bag Weight (-)</span>
                            <span>{(parseFloat(summary.total_weight) - parseFloat(summary.net_weight)).toFixed(2)}</span>
                        </div>
                        <div className="d-flex justify-content-between border-top mt-1 pt-1 fw-bold" style={{ fontSize: "14px" }}>
                            <span>Net Kg</span>
                            <span>{parseFloat(summary.net_weight).toFixed(2)}</span>
                        </div>
                        <div className="d-flex justify-content-between mt-1">
                            <span>Rate</span>
                            <span>{parseFloat(summary.rate).toFixed(2)}</span>
                        </div>
                        <div className="d-flex justify-content-between border-top border-bottom mt-1 py-1 fw-bold" style={{ fontSize: "15px" }}>
                            <span>Grand Total</span>
                            <span>₹ {parseFloat(summary.total_amount).toLocaleString('en-IN', { minimumFractionDigits: 2 })}</span>
                        </div>
                    </div>

                    {/* Footer */}
                    <div className="text-center mt-4 pt-2">
                        <p className="m-0 small fw-bold">Thank You!</p>
                        <p className="m-0 small">Visit Again</p>
                        <div className="mt-3" style={{ fontSize: '8px', color: '#666' }}>
                            * Computer generated document, signature not required.
                        </div>
                    </div>

                </CardBody>
            </Card>

            {/* Print Styling for Thermal Printer */}
            <style>
                {`
                    @media print {
                        .no-print { display: none !important; }
                        body { background: white !important; padding: 0 !important; margin: 0 !important; }
                        .container { max-width: 100% !important; width: 100% !important; padding: 0 !important; }
                        .card { border: none !important; box-shadow: none !important; width: 100% !important; }
                        @page { size: 80mm auto; margin: 2mm; }
                    }
                `}
            </style>
        </Container>
    );
};

export default PurchaseReceiptView;